<div *ngIf="show || static" class="main-warpper">
  <div class="app-loading">
    <div class="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>